<div class="pre-loader" *ngIf="!doneLoading"></div>
<div class="site-container">
    <div class="login-wrap">
        <div class="login-content">
            <div class="inner" [ngSwitch]="pageMode">
                <img class="logo" src="images/PDX-logo.svg" alt="PDx" />
                <div id="login-form" *ngSwitchCase="'setPassword'">
                    <form novalidate #setPasswordForm="ngForm" [ngClass]="{'was-validated': submitAttempt}"
                        [mustMatch]="['password', 'confirmPassword']">
                        <div class="animated-input input-inline-icon mb-3">
                            <input type="password" focus-me name="password"
                                class="form-control form-control-lg border-left-0" placeholder="Password" required
                                [(ngModel)]="login.password" />
                            <span class="underline"></span>
                            <span class="input-icon"><i class="fal fa-lock"></i></span>
                            <div class="invalid-feedback">
                                <i class="fas fa-exclamation-circle"></i> This field is required.
                            </div>
                        </div>
                        <div class="mb-0 override-small" *ngIf="login.password">
                            <password-strength-meter [password]="login.password" enableFeedback="true"
                                (strengthChange)="strengthChanged($event)"></password-strength-meter>
                            <input type="number" min="3" name="passwordStrength" class="form-control"
                                [(ngModel)]="login.passwordStrength" style="display:none;" />
                            <div class="invalid-feedback">
                                <i class="fas fa-exclamation-circle"></i> Please provide a strong password.
                            </div>
                        </div>
                        <div class="animated-input input-inline-icon mb-4">
                            <input type="password" #confirmPassword="ngModel" name="confirmPassword"
                                class="form-control form-control-lg"
                                [ngClass]="{'is-invalid': submitAttempt && (setPasswordForm.controls['confirmPassword'].errors)}"
                                placeholder="Confirm Password" required [(ngModel)]="login.confirmPassword" />
                            <span class="underline"></span>
                            <span class="input-icon"><i class="fal fa-lock"></i></span>
                            <div class="invalid-feedback">
                                <i class="fas fa-exclamation-circle"></i> Please provide a matching password.
                            </div>
                        </div>
                        <div class="d-grid">
                            <button type="submit" class="btn btn-lg btn-primary btn-round mt-3 text-strong hvr-grow"
                                (click)="doSetPassword()">Set Password <i class="far fa-arrow-right"></i></button>
                        </div>
                    </form>
                </div>
                <div id="forgot-password-form" *ngSwitchCase="'confirm'">
                    <h4 class="text-strong mb-1">Set Password</h4>
                    <p>Enter your account’s email address and we will email you a link to reset your password.</p>
                    <h5 class="mt-5 text-center text-normal"><a id="login-back-link" class="text-body"
                            href="javascript:void(0)" [routerLink]="['/login']"><i class="far fa-arrow-left"></i> back
                            to login</a></h5>
                </div>
            </div>
        </div>
        <div class="marbles-img">
            <img src="images/marbles.svg" alt="marbles" />
        </div>
    </div>
</div>